import { PageContainer, PageHeader } from "@touche-lts/panel-ui/dist"
import { IconUserManagement } from 'assets/icons'
import { useRootStore } from "mobx-stores/store-provider"
import { useEffect } from "react"
import { DepartmentsTable } from "./departments-table/departments-table-page"

const DepartmentsPageComponent = (props) => {
  const {
    className,
    style,
    history: { push }
  } = props,
    {
      departmentsStore: {
        resetStore
      },
      imagesStore: {
        clearStore
      }
    } = useRootStore()

  useEffect(() => {
    resetStore()
    clearStore()
  }, [resetStore, clearStore])

  return (
    <PageContainer className={className} style={style}>
      <PageHeader
        navSegments={[
          {
            icon: IconUserManagement,
            label: 'Departments',
            iconProps: { viewBox: '0 0 22 22' }
          }
        ]}
        buttons={[
          {
            preset: 'primary',
            children: 'Add department',
            onClick: () => push('/departments/add')
          }
        ]}
      />
      <DepartmentsTable />
    </PageContainer>
  )
}

const DepartmentsPage = DepartmentsPageComponent
export { DepartmentsPage }
